import { blupayApi, getApiError } from "../api/client";
import { tokenService } from "../api/token.service";

/**
 * onboardingService
 *
 * Backs the "Finish Setup" page a WhatsApp user lands on after chat captures
 * their name + country. Both endpoints are public (no access token) — the
 * WhatsApp phone number and profile fields travel inside the signed
 * onboarding token, never as request parameters the browser controls.
 *
 *   GET  /api/v1/auth/onboarding/prefill?token=...   — safe prefill (masked phone)
 *   POST /api/v1/auth/onboarding/complete            — creates the account (sets tokens)
 */
export const onboardingService = {
  async getPrefill(token) {
    try {
      const res = await blupayApi.get("/auth/onboarding/prefill", {
        params: { token },
      });
      return res.data;
    } catch (error) {
      throw getApiError(error);
    }
  },

  async complete({ token, password, email, gender, source_of_funds }) {
    try {
      const res = await blupayApi.post("/auth/onboarding/complete", {
        token,
        password,
        email,
        gender,
        source_of_funds,
      });

      if (res.data?.access_token && res.data?.refresh_token) {
        tokenService.setTokens(res.data.access_token, res.data.refresh_token);
      }

      return res.data;
    } catch (error) {
      throw getApiError(error);
    }
  },
};
